/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Typography } from "@mui/material";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
// import { useGetCurrentWebpage } from "hooks/useGetCurrentWebpage";
// Warning: Using display in edit
// import { NavCardsSection } from "cms/components/components/nav-cards/display/section-list";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";

function NavCardsComponentEditor () {
    
    // const webpage = useGetCurrentWebpage();
    const { component, updateFactory } = useUpdateComponent();
    
    const onChangeDescription = updateFactory("description");

    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='overline' color={"text.secondary"}>
                Description:{" "}
            </Typography>
            <SimplicityComposerEnsureTipTap
                richtext={component.description}
                onChange={onChangeDescription}
            />
            <div className="simplicity-nav-cards-editor-description">
                <Typography variant='body2' color='text.secondary'>
                    (Nav Cards Component is generated on the client by getting child navigation
                    items, based on this page in the navigation tree. You can see this in Preview.)
                </Typography>
            </div>
        </div>
    );
}

NavCardsComponentEditor.displayName = "NavCardsComponentEditor";
export { NavCardsComponentEditor }; 
